import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  loading: false,
  error: null,
  subscriptions: [],
};

const subscriptionsSlice = createSlice({
  name: "subscriptions",
  initialState,
  reducers: {
    loadSubscriptionsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadSubscriptionsSuccess(state, action: any) {
      state.loading = false;
      state.error = null;
      state.subscriptions = action?.payload?.results;
      state.paginationOption = {
        page: action.payload?.page,
        pageSize: action.payload?.pageSize,
        totalItems: action.payload?.totalItems,
        numberOfPages: action.payload?.numberOfPages,
      };
    },
    loadSubscriptionsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadSubscriptionsRequested,
  loadSubscriptionsSuccess,
  loadSubscriptionsFail,
} = subscriptionsSlice.actions;

export default subscriptionsSlice.reducer;
